module.exports=function(scope){ return `<div class="dt-gnm-menu-root">
  <div class="dt-gnm-menu-panel">
    <div class="global-menu-close">
      ${scope.closeIcon}
    </div>
    <div class="dt-gnm-menu-container">
      <div class="dt-gnm-menu-items">
      </div>
    </div>
  </div>
  <div class="dt-gnm-menu-background">
    <div></div>
  </div>
</div>
`};


// WEBPACK FOOTER //
// ./src/templates/global-menu-container.tpl.html